import React from 'react';
import { Grid } from '@mui/material';

interface GridItemProps {
  children: React.ReactNode;
  xs?: number | boolean;
  sm?: number | boolean;
  md?: number | boolean;
  lg?: number | boolean;
  xl?: number | boolean;
  sx?: any;
}

/**
 * GridItem is a wrapper component around Material UI's Grid
 * that works around the 'item' prop type issues in MUI v7
 */
const GridItem: React.FC<GridItemProps> = ({ children, ...props }) => {
  // Here we create the Grid with props directly, ignoring type checking
  // @ts-ignore - This suppresses the TypeScript error for the 'item' prop
  return <Grid item {...props}>{children}</Grid>;
};

export default GridItem; 